import { Famille } from "./families.model";

export class Article {
  id: number;
  reference: string;
  designation: string;
  price: number;
  length: number;
  weight: number;
  unit: string;
  famille: Famille;

  constructor() {
    this.famille = new Famille();
  }
}

export class ArticleForm {
  id: number;
  reference: string;
  designation: string;
  price: number;
  length: number;
  weight: number;
  unit: string;
  famille: number;

  constructor() {}
}
